import type { Extras, SeverityLevel } from '@sentry/types';
import { captureException } from './lazy-sentry';

export type TrackErrorBaseParams = {
  name: string;
  error: unknown;
  extra?: Extras;
  tags?: Record<string, string>;
  level?: SeverityLevel;
};

export type TrackErrorParams = TrackErrorBaseParams & {
  user: {
    visitorId: string;
    userId?: string;
    email?: string;
    isAnonymous?: boolean;
    stripeCustomerId?: string | null;
  };
};

export const trackError = ({ name, error, extra, tags, level, user }: TrackErrorParams) => {
  const { userId, visitorId, email, isAnonymous, stripeCustomerId } = user;

  // wrap strings so they group by call-site stack instead of their (often interpolated) message
  const exception = typeof error === 'string' ? new Error(error) : error;

  if (process.env.NODE_ENV === 'development') {
    // eslint-disable-next-line no-console
    console.error(`\n[DEBUG ERROR] ${name}:`, exception, extra, '\n');
    return;
  }

  captureException(exception, {
    user: { id: userId || 'unidentified', email },
    extra,
    tags: { ...tags, errorName: name, visitorId, isAnonymous, stripeCustomerId },
    level,
  });
};
